<script setup lang="ts">
const $attrs = useAttrs()

const props = withDefaults(defineProps<{
    colgap?: number | 'auto'
    w?: string
  }>(), { w: '', snap: 400 })

const elStyle = computed(() => {
  if (props.colgap) {
    return {
      'grid-column-gap': `${props.colgap}rem`,
    }
  }
})

const filteredAttrs = computed(() => {
  const myAttrs = { ...$attrs }
  delete myAttrs.class

  return myAttrs
})

const wrap = ref()

const slots = useSlots()
const frame = ref()
defineExpose({
  frame
})
</script>

<template>
  <div ref="frame" class="m-frame">
    <slot name="before" v-if="slots.before"></slot> 
    <!-- snap -->
    <Wrap ref="wrap" :style="elStyle" :class="w" v-bind="filteredAttrs">
      <slot />
    </Wrap>
    
    <slot name="after" v-if="slots.after"></slot> 
  </div>
</template>

<style lang="scss" scoped>
.m-frame {

  &:slotted(> .bg-layer) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &.attach {
      background-attachment: fixed;
    }
  }

  >.m-wrap {
    width:100%;
    // display:grid;
    //grid-auto-flow: column;

    // Represents the first child column of this element
    &:slotted(> .m-col) {
      // box-shadow: inset 0 0 0 1px black;
    }
    &:slotted(> .m-col) {
      // box-shadow: inset 0 0 0 1px black;
    }

    &.snap {
      // @include mq($until: t) {
        &:slotted(> .m-col) {
          grid-column: 1/-1;
        }
      // }
    }
  }
}
</style>
